export class Company {
    id:string = "";
    name:string = "";
    zip:string = "";
    city:string = "";
    street:string = "";
    streetnumber:string = "";
    userId:string = "";
    phoneNumber:string = "";
    dialCode:string = "";
}